export class LeadsForm {
  id = "";
  companyName = "";
  leadNumber = "";
  voi_series_derivative_desc_c:"";
  voi_engine_type_c:"";
  voi_exterior_color_desc_c:"";
  voi_interior_color_desc_c:"";
  voi_options_c:"";
  assignedTo: {
    id: number,
    userName: string,
    firstName: string,
    lastName: string
  };
  dealerId: {
    id: string,
    superDealerCode: string,
    name: string,
    globalCode: string,
    localCode: string,
    regionCode: string,
    countryCode: string
  };
  teamId: {
    id: string,
    name: string
  };
  prospectId: {
    id: string,
    firstName: string,
    lastName: string,
    companyName: string,
    phone: string,
    phoneTimeToCall: string,
    mobile: string,
    mobileTimeToCall: string,
    email: string,
    addressId: {
      id: string,
      address1: string,
      city: string,
      postalCode: string,
      stateId: {
        id: string,
        stateCode: string,
        name: string
      },
      countryId: {
        id: string,
        code: string,
        name: string
      }
    }
    assignedTo: {
      id: number,
      userName: string,
      firstName: string,
      lastName: string
    };
  };
  sourceId: { id: number, sourceType: string };
  priorityId: { id: number, priority: string };
  intentionId: { id: number, intention: string };
  eventId: { id: number, eventId: number, eventDescription: string };
  currentVehicle: { id: number, make: string, model: string };
  vehicleOfInterest: { id: number, make: string, model: string };
  callToAction: { id: number, ctaType: string };
  statusId: { id: number, statusType: string };
  submissionDate = new Date();
  updationDate = new Date();
  activity: [{}];
  userId = "";
  vehiclePurposeId: { id: string, code: string, description: string, active: boolean };
  comments = "";
  website = "";
  campaignName = "";
  adobeIdC = "";

  constructor(id: string,
              companyName: string,
              assignedTo: any,
              dealerId: any,
              teamId: any,
              prospectId: any,
              sourceId: any,
              priorityId: any,
              intentionId: any,
              eventId: any,
              currentVehicle: any,
              vehicleOfInterest: any,
              callToAction: any,
              statusId: any,
              submissionDate: Date,
              voi_series_derivative_desc_c:any,
              voi_engine_type_c:any,
              voi_exterior_color_desc_c:any,
              voi_interior_color_desc_c:any,
              voi_options_c:any,
              updationDate: Date,
              activity: any,
              userId: string,
              vehiclePurposeId: any,
              comments: string,
              website: string,
              campaignName: string,
              adobeIdC) {
    this.id = id;
    this.companyName = companyName;
    this.assignedTo = assignedTo;
    this.dealerId = dealerId;
    this.teamId = teamId;
    this.prospectId = prospectId;
    this.sourceId = sourceId;
    this.priorityId = priorityId;
    this.intentionId = intentionId;
    this.eventId = eventId;
    this.currentVehicle = currentVehicle;
    this.vehicleOfInterest = vehicleOfInterest;
    this.callToAction = callToAction;
    this.statusId = statusId;
    this.submissionDate = submissionDate;
    this.updationDate = updationDate;
    this.activity = activity;
    this.userId = userId;
    this.vehiclePurposeId = vehiclePurposeId;
    this.comments = comments;
    this.website = website;
    this.campaignName = campaignName;
    this.adobeIdC = adobeIdC;
    this.voi_series_derivative_desc_c=voi_series_derivative_desc_c;
      this.voi_engine_type_c= voi_engine_type_c;
      this.voi_exterior_color_desc_c= voi_exterior_color_desc_c;
      this.voi_interior_color_desc_c= voi_interior_color_desc_c;
      this.voi_options_c= voi_options_c;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leads/models/data-model.ts